// Búsqueda global (⌘K / Ctrl+K o "/"): clientes por razón social o CUIT y
// archivos por nombre o categoría, solo de los clientes que ve el usuario.
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Kbd, UnstyledButton, Group, Text } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { Spotlight, spotlight } from '@mantine/spotlight';
import { useQuery } from '@tanstack/react-query';
import { IconBuildingBank, IconFile, IconSearch } from '@tabler/icons-react';
import { formatearCuit, type ResultadoBusqueda } from '@epms/shared';
import { api } from '../api.ts';
import { RUTAS } from '../rutas.ts';

export function Buscador() {
  const navegar = useNavigate();
  const [consulta, setConsulta] = useState('');
  const [q] = useDebouncedValue(consulta.trim(), 250);
  const { data, isFetching } = useQuery({
    queryKey: ['buscar', q],
    queryFn: () => api.get<ResultadoBusqueda>(`/api/buscar?q=${encodeURIComponent(q)}`),
    enabled: q.length >= 2,
    staleTime: 30_000,
  });
  const vacio = !data || (!data.clientes.length && !data.archivos.length);

  return (
    <>
      <UnstyledButton onClick={spotlight.open} visibleFrom="xs"
        style={{ border: '1px solid var(--mantine-color-default-border)', borderRadius: 8, padding: '4px 10px' }}>
        <Group gap={8} wrap="nowrap">
          <IconSearch size={14} />
          <Text size="sm" c="dimmed">Buscar cliente o archivo</Text>
          <Kbd size="xs">⌘K</Kbd>
        </Group>
      </UnstyledButton>
      <Spotlight.Root query={consulta} onQueryChange={setConsulta} shortcut={['mod + K', '/']} scrollable maxHeight={480}>
        <Spotlight.Search placeholder="Razón social, CUIT o nombre de archivo" leftSection={<IconSearch size={18} />} />
        <Spotlight.ActionsList>
          {q.length < 2 ? <Spotlight.Empty>Escribí al menos 2 letras</Spotlight.Empty>
            : vacio ? <Spotlight.Empty>{isFetching ? 'Buscando…' : 'No se encontró nada'}</Spotlight.Empty> : (
              <>
                {!!data.clientes.length && (
                  <Spotlight.ActionsGroup label="Clientes">
                    {data.clientes.map((c) => (
                      <Spotlight.Action key={`c${c.id}`} label={c.razonSocial} description={formatearCuit(c.cuit)}
                        leftSection={<IconBuildingBank size={18} />} onClick={() => navegar(RUTAS.cliente(c.id))} />
                    ))}
                  </Spotlight.ActionsGroup>
                )}
                {!!data.archivos.length && (
                  <Spotlight.ActionsGroup label="Archivos">
                    {data.archivos.map((a) => (
                      <Spotlight.Action key={`a${a.id}`} label={a.nombre}
                        description={[a.razonSocial, a.categoria, a.periodo].filter(Boolean).join(' · ')}
                        leftSection={<IconFile size={18} />} onClick={() => navegar(RUTAS.cliente(a.clienteId))} />
                    ))}
                  </Spotlight.ActionsGroup>
                )}
              </>
            )}
        </Spotlight.ActionsList>
      </Spotlight.Root>
    </>
  );
}
